<div class="steam-buster-report">
  <div class="report-header">
    <p class="section-title">
      {{ pageType === 'orphan' ? 'TLR Orphan Report' : pageType === 'onrun' ? 'On The Run TLRs' : pageType === 'steamBuster' ? 'Steam Buster Report' : pageType === 'abandoned' ? 'Abandoned/Out of Service Equipment' : '' }}</p> 

    <button (click)="exportToExcel()">Export To Excel</button>

  </div>
  <div class="report-content section-wrapper" style="max-height: none;">

    <p-table
       responsiveLayout="stack" 
      [value]="initReportData"
      [paginator]="true"  [rows]="10"
      [scrollable]="true" >
      <ng-template pTemplate="header">
        <tr>

          <th>Tag Number</th>
          <th>Entry Date</th>
          <th>Op. User ID</th>
          <th>Division</th>
          <th>Section</th>
          <th>Plant</th>
          <th>LDAR</th>
          <th>Op. PSI</th>
          <th>Op. Temp</th>
          <th>Service</th>
          <th>Insp. User ID</th>
          <th>Service Class</th>
          <th>OA User ID</th>
          <th>Permanent Repair Date</th>
          <th>Eng. User ID</th>
          <th>TLR Type</th>
          <th *ngIf="pageType == 'orphan'">Permanent Repair
            WO Number</th>
           <th *ngIf="pageType != 'orphan'">Maximo WO Number</th>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>

          <td>
            <a class="Clickable" 
            routerLink="/details-section/{{item.Tag_Number}}">{{item.Tag_Number}}</a>
                </td>
          <td> {{item["Data_Entry_Date"]| date:'MM/dd/yyyy'}}</td>
          <td>{{item["Operator_CAI"]}}</td>
          <td>{{item["Division"]}}</td>
          <td>{{item["Section"]}}</td>
          <td>{{item["Plant"]}}</td>
          <td>{{item["LDAR"]}}</td>
          <td>{{item["Oper_PSI"]}}</td>
          <td>{{item["Oper_Temp"]}}</td>
          <td>{{item["Service"]}}</td>
          <td>{{item["InspectionCAI"]}}</td>
          <td>{{item["ServiceClass"]}}</td>
          <td>{{item["OACAI"]}}</td>
          <!-- date = 1/1/1900 ==> empty ; date< current date ==> permanent-red  data >= current date ==> permanent-green -->
            <td class="red">
            {{item["Permanent_Repair_Date"]| date:'MM/dd/yyyy'}}
            </td>
          <td>{{item["EngineeringCAI"]}}</td>
          <td>{{item["TLRType"]}}</td>
          <td *ngIf="pageType !== 'orphan'">{{item["Maximo_WO_Number"]}}</td>
          <td *ngIf="pageType === 'orphan'">{{item["Permanent_Repair_WO_Number"]}}</td>


        </tr>
      </ng-template>
    </p-table>

  </div>